import { Component, Input, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { environment } from '../../../services/global-environment';
import { Subject } from 'rxjs';
import { FormsModule } from '@angular/forms';

@Component({
  selector: 'app-sds-parser',
  standalone: true,
  imports: [CommonModule,FormsModule],
  templateUrl: './sds-parser.component.html',
  styleUrl: './sds-parser.component.scss'
})
export class SdsParserComponent implements OnInit {

  @Input() selectedfile: File | null = null;

  @Input() selecteditem: any = {};
  @Input() viewmodel:boolean = false;

  showTabHeader = false;

  selectedfilname: string = '';
  selectedfileurl: string = '';

  private apiUrl = environment.apiUrl;
  private companyId = environment.companyid;
  selectedFile: File | null = null;
  loading = false;
  // S0~S16
  parsercontenttemp_0 = '';
  parsercontenttemp_1 = '';
  parsercontenttemp_2 = '';
  parsercontenttemp_3 = '';
  parsercontenttemp_4 = '';
  parsercontenttemp_5 = '';
  parsercontenttemp_6 = '';
  parsercontenttemp_7 = '';
  parsercontenttemp_8 = '';
  parsercontenttemp_9 = '';
  parsercontenttemp_10 = '';
  parsercontenttemp_11 = '';
  parsercontenttemp_12 = '';
  parsercontenttemp_13 = '';
  parsercontenttemp_14 = '';
  parsercontenttemp_15 = '';
  parsercontenttemp_16 = '';

  // 正則表達式與 dialog 寫法一致
  private regex: RegExp = /\[S(\d+)\]\s*([\s\S]*?)(?=\[|$)/g;
  finished: boolean[] = Array(17).fill(false);

  // Tab 狀態: 0=分段, 1=JSON
  activeTab = 0;
  parsedModel: any = null;
  parsedModelRaw: string = '';

  // 中文 mapping
  private sectionTitleMap: string[] = [
    '0.基本資訊', '1.化學品與廠商資訊', '2.危害辨識資料', '3.成分辨識資料', '4.急救措施', '5.滅火措施',
    '6.洩漏處理方法', '7.安全處置與儲存方法', '8.暴露預防措施', '9.物理及化學性質', '10.安定性及反應性',
    '11.毒性資料', '12.生態資料', '13.廢棄處置方法', '14.運送資料', '15.法規資料', '16.其他資料'
  ];

  private fieldLabelMap: { [idx: number]: { [key: string]: string } } = {
    0: {
      CreateUnitName: '製表單位名稱',
      CreateUnitAddress: '製表單位地址',
      CreateUnitPhoneNumber: '製表單位電話',
      CreateName: '製表人姓名',
      CreaterTitle: '製表人職稱',
      CreateDate: '製表日期',
      CreateRemark: '備註'
    },
    1: {
      ItemName: '化學品名稱',
      ChemicalZhName: '化學品中文名稱',
      ChemicalEnName: '化學品英文名稱',
      ChemicalOtherName: '其他名稱',
      UsageLimition: '建議用途與限制使用',
      SupplierCompanyName: '供應者名稱',
      SupplierAddress: '供應者地址',
      SupplierPhone: '供應者電話',
      EmergencyContactPhone: '緊急連絡電話',
      EmergencyContactFax: '緊急連絡傳真'
    },
    2: {
      HazardValues: 'GHS分類',
      WarningText: '警示語',
      HazardAlertMessage: '危害警告訊息',
      HazardPreventiveMeasures: '危害防範措施'
    },
    3: {
      MaterialComposition: '純物質或混合物',
      materials: '危害成分'
    },
    4: {
      Inhalation: '吸入',
      SkinContact: '皮膚接觸',
      EyeContact: '眼睛接觸',
      Ingestion: '食入',
      MajorDiseaseAndHazardousEffect: '最重要症狀及危害效應',
      ProtectionOfFirstAidPerson: '對急救人員之防護',
      NotesToDoctor: '對醫師之提示'
    },
    5: {
      SuitableExtinguishingMedia: '適用滅火器',
      SpecialHazardsWhenExtinguishing: '滅火時可能遭遇之特殊危害',
      SpecialExtinguishingProcedure: '特殊滅火程序',
      SpecialProtectiveEquipmentForFireFighters: '消防人員之特殊防護裝置',
      RescueMethod: '救援方法'
    },
    6: {
      PersonalProtection: '個人應注意事項',
      EnvironmentalProtection: '環境注意事項',
      MethodsForCleaningUp: '清理方法'
    },
    7: {
      Handling: '處置',
      Storage: '儲存',
      Packaging: '包装方法/材料'
    },
    8: {
      EngineeringControls: '工程控制',
      RespiratoryProtection: '呼吸防護',
      HandProtection: '手部防護',
      EyeProtection: '眼睛防護',
      BodyProtection: '皮膚及身體防護',
      HygieneMeasures: '衛生措施'
    },
    9: {
      PhysicalState: '外觀',
      ItemColor: '顏色',
      ItemSmell: '氣味',
      PH: 'pH值',
      ItemSmellLimit: '嗅覺閥值',
      MeltingPoint: '熔點',
      BoilingPoint: '沸點',
      DecompositionTemp: '分解溫度',
      VaporDensity: '蒸氣密度',
      AutoIgnitionTemp: '自燃溫度',
      Solubility: '溶解度',
      VaporPressure: '蒸氣壓',
      Density: '密度',
      Kow: '水分配係數'
    },
    10: {
      Stability: '安定性',
      PossibilityOfHazardousReaction: '特殊情況下之可能之危害反應',
      ConditionsToAvoid: '應避免之情況',
      IncompatibleMaterials: '應避免之物質',
      HazardousDecompositionProducts: '危害分解物'
    },
    11: {
      ToxicExposurePath: '暴露途徑',
      ToxicSymptom: '症狀',
      AcuteToxicity: '急毒性',
      LD50: '急性毒性指數-(LD50)',
      LC50: '急性毒性指數-半致死量(LC50)',
      ChronicToxicity: '慢毒性或長期毒性'
    },
    12: {
      EcoToxicity: '生態毒性',
      PersistenceAndDegradability: '持久性及降解性',
      BioaccumulativePotential: '生體蓄積性',
      MobilityInSoil: '土壤中之流動性',
      OtherAdverseEffects: '其他不良效應'
    },
    13: {
      DisposalConsiderations: '廢棄處置方法'
    },
    14: {
      UnNumber: '聯合國編號',
      TranspaortName: '聯合國運送名稱',
      TransportHazardClassfication: '運輸危害分類',
      PackageClass: '包裝類別',
      OceanCorrupt: '海洋汙染物',
      TransportMemo: '特殊運送方法及注意事項'
    },
    15: {
      RelatedLawInfo: '適用法規'
    },
    16: {
      References: '參考文獻'
    }
  };

    ngOnInit(): void {


      console.log('selecteditem:', this.selecteditem);

this.selectedfilname = this.selecteditem?.filename || '';
this.selectedfileurl = this.selecteditem?.fileurl || '';

    console.log('selectedfilname:', this.selectedfilname);
    console.log('selectedfileurl:', this.selectedfileurl);

    if (this.viewmodel) {
      this.parsedModel = this.selecteditem.sds_details;
      this.showTabHeader = true;
      this.activeTab = 2;
    }
  }

  getSectionTitle(idx: number): string {
    return this.sectionTitleMap[idx] || `項目${idx}`;
  }
  getFieldLabel(idx: number, key: string): string {
    return (this.fieldLabelMap[idx] && this.fieldLabelMap[idx][key]) ? this.fieldLabelMap[idx][key] : key;
  }

  get finishedCount(): number {
    return this.finished.filter(x => x).length;
  }
  get progressPercent(): number {
    return Math.round((this.finishedCount / 17) * 100);
  }

  onFileSelected(event: any) {
    this.selectedFile = event.target.files[0] || null;
    this.selectedfile = this.selectedFile;
  }

  uploadAndParse() {
    if (!this.selectedFile && !this.selectedfileurl) return;

    this.showTabHeader = true;

    this.loading = true;
    this.activeTab = 0;
    this.parsedModel = null;
    this.parsedModelRaw = '';
    // Reset all content
    for (let i = 0; i <= 16; i++) {
      (this as any)[`parsercontenttemp_${i}`] = '';
      this.finished[i] = false;
    }

    const formData = new FormData();
    if (this.selectedFile) {
    formData.append('file', this.selectedFile);
    }

    if (this.selectedfileurl) {
    formData.append('fileurl', this.selectedfileurl);
    }

    formData.append('companyid', this.companyId);
    formData.append('targetlist', '-1');

    this.sdsParseWithFetch(formData).subscribe({
      next: (chunk: string) => {


        this.processSdsStreamChunk(chunk);
      },
      error: () => {
        this.loading = false;
      },
      complete: () => {
        this.loading = false;
      }
    });
  }

  private sdsParseWithFetch(formData: FormData) {


    console.log('sdsParseWithFetch called with formData:', formData);

    const url = `${this.apiUrl}/api/sdsparsertw`;

    console.log('API URL:', url);


    const resultSubject = new Subject<string>();

    fetch(url, {
      method: 'POST',
      body: formData,
      headers: {
        Accept: 'text/event-stream'
      }
    })
      .then(response => {
        if (!response.ok) throw new Error('Network response was not ok');
        if (!response.body) throw new Error('Response body is null');

        const reader = response.body.getReader();
        const decoder = new TextDecoder();

        function read() {
          reader.read().then(({ done, value }) => {
            if (done) {
              resultSubject.complete();
              return;
            }
            const chunk = decoder.decode(value, { stream: true });
            resultSubject.next(chunk);
            read();
          }).catch(error => {
            console.error('Error reading stream:', error);
            resultSubject.error(error);
          });
        }
        read();
      })
      .catch(error => {
        console.error('Fetch error:', error);
        resultSubject.error(error);
      });

    return resultSubject.asObservable();
  }


  private processSdsStreamChunk(chunk: string) {
    // 只要 chunk 包含 result: {"model": 就處理
    if (chunk.includes('result: {"model":')) {
      // 將 result: {"model": 換成 {，event: end 換成空
      let jsonStr = chunk.replace('result: ', '').replace('event: end', '').trim();
      try {
        const json = JSON.parse(jsonStr);

        this.parsedModel = json.model;

        console.log(json.model);

        this.parsedModelRaw = JSON.stringify(json.model, null, 2);
        setTimeout(() => {}, 0);
      } catch (e) {
        this.parsedModel = null;
        this.parsedModelRaw = '解析失敗';
      }
    }

    let match;
    while ((match = this.regex.exec(chunk)) !== null) {
      const key = `${match[1]}`;
      const idx = parseInt(key, 10);
      const value = match[2];
      if (value.trim() === 'Done') {
        if (idx >= 0 && idx <= 16) this.finished[idx] = true;
        continue; // 不顯示 Done
      }
      switch (key) {
        case '0':
          this.parsercontenttemp_0 += this.fommateparsercontent(value);
          break;
        case '1':
          this.parsercontenttemp_1 += this.fommateparsercontent(value);
          break;
        case '2':
          this.parsercontenttemp_2 += this.fommateparsercontent(value);
          break;
        case '3':
          this.parsercontenttemp_3 += this.fommateparsercontent(value);
          break;
        case '4':
          this.parsercontenttemp_4 += this.fommateparsercontent(value);
          break;
        case '5':
          this.parsercontenttemp_5 += this.fommateparsercontent(value);
          break;
        case '6':
          this.parsercontenttemp_6 += this.fommateparsercontent(value);
          break;
        case '7':
          this.parsercontenttemp_7 += this.fommateparsercontent(value);
          break;
        case '8':
          this.parsercontenttemp_8 += this.fommateparsercontent(value);
          break;
        case '9':
          this.parsercontenttemp_9 += this.fommateparsercontent(value);
          break;
        case '10':
          this.parsercontenttemp_10 += this.fommateparsercontent(value);
          break;
        case '11':
          this.parsercontenttemp_11 += this.fommateparsercontent(value);
          break;
        case '12':
          this.parsercontenttemp_12 += this.fommateparsercontent(value);
          break;
        case '13':
          this.parsercontenttemp_13 += this.fommateparsercontent(value);
          break;
        case '14':
          this.parsercontenttemp_14 += this.fommateparsercontent(value);
          break;
        case '15':
          this.parsercontenttemp_15 += this.fommateparsercontent(value);
          break;
        case '16':
          this.parsercontenttemp_16 += this.fommateparsercontent(value);
          break;
        default:
          break;
      }
    }
  }

  fommateparsercontent(data: string): string {
    var result = data
      .replace('```', '')
      .replace('json', '')
      .replace('},', ',<br>')
      .replace('{', '<br>')
      .replace('}', '<br>')
      .replace('",', '",<br>');

    return result;
  }

  objectKeys(obj: any): string[] {
    return obj ? Object.keys(obj) : [];
  }
  isArray(val: any): boolean {
    return Array.isArray(val);
  }



}
